export default "__VITE_ASSET__DiyeFWtA__"